import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Shield, LogIn } from "lucide-react";
import { Input } from "../components/ui/input";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const res = await fetch(`${BACKEND_URL}/api/auth/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({ email, password }),
      });
      if (!res.ok) {
        const data = await res.json();
        throw new Error(data.detail || "Login failed");
      }
      const data = await res.json();
      localStorage.setItem("admin_token", data.token);
      navigate("/admin/dashboard");
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#F9FAFB] flex items-center justify-center px-4" data-testid="admin-login-page">
      <div className="w-full max-w-sm">
        <div className="text-center mb-8">
          <div className="inline-flex items-center gap-2 mb-4">
            <Shield className="w-6 h-6 text-[#06B6D4]" />
            <span className="font-['Outfit'] font-bold text-xl text-[#0F172A]">Admin</span>
          </div>
          <p className="text-sm text-[#6B7280]">Sign in to manage your portfolio</p>
        </div>

        <form onSubmit={handleLogin} className="bg-white border border-[#E5E7EB] rounded-2xl p-6 space-y-4 shadow-sm" data-testid="admin-login-form">
          <div>
            <label className="text-sm font-medium text-[#111827] mb-1.5 block">Email</label>
            <Input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="admin@shiftleftsec.in"
              required
              className="bg-white border-[#E5E7EB]"
              data-testid="admin-email-input"
            />
          </div>
          <div>
            <label className="text-sm font-medium text-[#111827] mb-1.5 block">Password</label>
            <Input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter password"
              required
              className="bg-white border-[#E5E7EB]"
              data-testid="admin-password-input"
            />
          </div>
          {error && <p className="text-sm text-red-500" data-testid="admin-login-error">{error}</p>}
          <button
            type="submit"
            disabled={loading}
            data-testid="admin-login-submit"
            className="w-full inline-flex items-center justify-center px-6 py-3 rounded-lg bg-[#0F172A] text-white font-medium transition-all hover:bg-[#111827] disabled:opacity-50"
          >
            {loading ? "Signing in..." : <><LogIn className="mr-2 w-4 h-4" /> Sign In</>}
          </button>
        </form>

        <button
          onClick={() => navigate("/")}
          className="block mx-auto mt-4 text-sm text-[#6B7280] hover:text-[#111827] transition-colors"
          data-testid="admin-back-btn"
        >
          Back to Portfolio
        </button>
      </div>
    </div>
  );
}
